module.exports = __webpack_public_path__ + "static/media/scdream6.07989553.woff2";